var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { motion } from "framer-motion";
import MenuSection from './menuSection';
import { Nav, NavLink, TabContent, TabPane } from 'reactstrap';
export default function StripTabMenu(props) {
    var fields = props.fields, isFlyoverSite = props.isFlyoverSite;
    var TitleTag = (fields.titleTag || 'h1');
    var _a = useState(0), activeTab = _a[0], setActiveTab = _a[1];
    var toggle = function (tab) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    var existTabs = function () {
        if (props.children) {
            for (var i = 0; i < props.children.length; i++) {
                if (props.children[i].stripClassName == "sky23.tabgroup") {
                    return true;
                }
            }
        }
        return false;
    };
    var hasTabs = existTabs();
    return (React.createElement(motion.div, __assign({ className: "strip sky23-tabs container-fluid position-relative component container-sm-px-0"
            + ((fields.background) ? (" bg-" + fields.background) : "")
            + ((isFlyoverSite && fields.textColor) ? (" text-color-" + fields.textColor) : "")
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {}), { itemScope: true, itemType: "https://schema.org/Menu" }),
        React.createElement("div", { className: "row" }, fields.displayTitle &&
            React.createElement("div", { className: "col mb-3 mt-4"
                    + (isFlyoverSite ? "" : " text-primary") }, fields.displayTitle &&
                React.createElement(TitleTag, { className: "display-4 text-center " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null)),
        hasTabs &&
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col mx-auto" },
                    React.createElement(Nav, { className: "nav nav-pills mb-5 justify-content-center" }, props.children && props.children.length > 0 && props.children.map(function (item, i) {
                        return (React.createElement(React.Fragment, null, item.stripClassName == "sky23.tabgroup" && React.createElement(NavLink, { className: "nav-item nav-link " + (activeTab === i ? "active" : ""), onClick: function () { toggle(i); }, href: "javascript:void(0);" }, item.fields.tabTitle) || null));
                    })),
                    React.createElement(TabContent, { className: "tab-content py-4"
                            + (isFlyoverSite ? "" : " text-primary"), id: "nav-tabContent", activeTab: activeTab }, props.children && props.children.length > 0 && props.children.map(function (item, j) {
                        return (React.createElement(React.Fragment, null, item.stripClassName == "sky23.tabgroup" && React.createElement(TabPane, { className: "tab-pane fade" + (activeTab === j ? " show" : ""), tabId: j, 
                            //id={"TabContent_" + j}
                            //role="tabpanel"
                            //aria-labelledby={"Tab_" + j}
                            tabIndex: j == 0 ? -1 : 0, key: "Content_" + j },
                            item && item.children && item.children.length > 0 && item.children.map(function (section, j) {
                                return (React.createElement(React.Fragment, null, section.stripClassName == "sky23.menusection" &&
                                    React.createElement(MenuSection, { item: section, key: "Section_" + j, isFlyoverSite: isFlyoverSite })));
                            }),
                            item && item.children == null &&
                                React.createElement("span", null, " Missing content")) || null));
                    })))),
        !hasTabs &&
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col mx-auto" }, props.children && props.children.length > 0 && props.children.map(function (section, j) {
                    return (React.createElement(React.Fragment, null, section.stripClassName == "sky23.menusection" &&
                        React.createElement(MenuSection, { item: section, key: "Section_" + j })));
                }))),
        !hasTabs && props.children == null && React.createElement("span", null, " Missing content") || null));
}
